
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.candidatsTitle}`,
            meta: this.infoGenerales?.attributes?.candidatsMeta != null && this.infoGenerales?.attributes?.candidatsMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.candidatsMeta?.replace('\n', '')) : null
        };
        // return {
        //     title: `Formulaire de candidature`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: "Postulez à l'ICFA - Candidatures ouvertes pour formations",
        //         },
        //         {
        //             hid: 'og-description',
        //             property: 'og:description',
        //             content: `Lancez votre avenir avec l’ICFA ! Découvrez comment postuler à nos programmes de formation en alternance en toute simplicité.`,
        //         }
        //     ]
        // };
    },
    data() {

        const isOpen = false
        const dublon = false
        
        let candidatsForm = {
            niveau: '',
            diplomeChoosen: '',
            campusChoosen: '',
            inscription: '',
            civilite: '',
            prenom: '',
            nom: '',
            telephone: '',
            email: '',
            dateOfBirth: '',
            codePostal: '',
            ville: '',
            mobilite: '',
            bacSerie: '',
            bac: '',
            diplomeDeNiveauBac2: '',
            diplomeDeNiveauBac3: '',
            resumeProjet: '',
            cv: null,
            entrepriseCandidats: '',
            planRegion: '',
            consent: '',
        };
        let listCities = [];

        let formSent = false;
        let sending = false;

        return {
            candidatsForm,
            diplomasType: [],
            filteredDiploma: [],
            filteredInstances: [],
            curentDiploma: {},
            departementExplantionNeeded: false,
            listCities,
            formSent, 
            sending,
            isMounted: false,
            isOpen,
            dublon,
        }
    },

    setup() {
        return { v$: useVuelidate() }
    },
    validations() {

        let validation = {
            candidatsForm: {
                niveau: { required },
                diplomeChoosen: { required },
                campusChoosen: { required },
                inscription: { required },
                civilite: { required },
                prenom: { required },
                nom: { required },
                email: { required, email },
                telephone: { required, mustBePhoneNumber },
                dateOfBirth: { required },
                codePostal: { required },
                ville: { required },
                mobilite: { required },
                consent: { required },
            }
           
        }

        if(this.candidatsForm.niveau == '1'){
            validation.candidatsForm.bacSerie =  { required };
            validation.candidatsForm.bac =  { required };
        }else {
            validation.candidatsForm.bacSerie =  { };
            validation.candidatsForm.bac =  { };
        }

        if(this.candidatsForm?.inscription == 'enAlternance'){
            validation.candidatsForm.entrepriseCandidats =  { required };
        }else {
            validation.candidatsForm.entrepriseCandidats =  { };
        }


        return validation;

    },
    mounted() {
        this.isMounted = true;
    },

    methods: {
        checkCandidatsForm() {
        },
        previewFiles(event) {
            this.candidatsForm.cv = event.target.files[0];
        },
        resetInput() {
            this.candidatsForm.cv = null;
        },
        clickNiveau() {
            this.candidatsForm.diplomeChoosen = ''
            this.candidatsForm.campusChoosen = ''
            this.filteredInstances = []
            this.filteredDiploma = this.allDiplomas.filter(diploma => diploma?.attributes?.niveauDiplome?.data?.id === this.candidatsForm.niveau)
            this.diplomasType = []
            
            this.filteredDiploma.map(diploma => {
                let diplomaTypeIndex = this.diplomasType.map(dt => dt.acronyme).indexOf(diploma.attributes.acronyme)
                if (diplomaTypeIndex == -1) {
                    let map = new Map();
                    this.diplomasType.push(
                        {
                            acronyme: diploma.attributes.acronyme,
                            title: diploma.attributes.title,
                            campus: [diploma.campus],
                            mapId: map.set(diploma.campus, diploma.id),
                            niveau: diploma.attributes.niveauDiplome.data.attributes.description,
                        })
                } else {
                    this.diplomasType[diplomaTypeIndex].campus.push(diploma.campus)
                    this.diplomasType[diplomaTypeIndex].mapId.set(diploma.campus, diploma.id)
                }
            })
        },
        clickDiploma() {
            this.candidatsForm.campusChoosen = ''
            this.curentDiploma = this.candidatsForm.diplomeChoosen
            if (this.candidatsForm.diplomeChoosen) {
                this.filteredInstances = this.instances.filter(instance => {
                    return this.curentDiploma.campus.includes(instance.attributes.prefix)
                })
            } else {
                this.filteredInstances = []

            }
        },
        async changeCodePostal() {
            let listCities = await this.$http.$get(`${process.env.apiCrmServer}villes.php?code_postal=${this.candidatsForm.codePostal}`);
            this.listCities = listCities.data;
            if (this.candidatsForm.codePostal.length > 4 && this.candidatsForm.codePostal.substring(0, 2) != '34' && this.candidatsForm.codePostal.substring(0, 2) != '30') {
                this.departementExplantionNeeded = true
            } else {
                this.departementExplantionNeeded = false
            }
        },
        clickSeries() {
            this.displayedBacs = this.bacs.filter(bac => bac.serie === this.candidatsForm.bacSerie)
        },

        chooseFiles() {
            document.getElementById("fileUploadCandidats").click()
        },
        async sendStudent() {

            try{
                if (await this.v$.$validate()) {
                    this.sending = true;
                    const realDiploma = this.allDiplomas.find(diploma => {
                        return diploma.attributes.acronyme == this.candidatsForm.diplomeChoosen.acronyme &&
                            diploma.campus == this.candidatsForm.campusChoosen.attributes.prefix
                    })
                    this.candidatsForm.diplome = realDiploma?.attributes?.idDiplomeCRM ?? 1;    
                    this.candidatsForm.diplomaAcronyme = this.candidatsForm.diplomeChoosen.acronyme;  
                    this.candidatsForm.campus = this.candidatsForm.campusChoosen.attributes.idCampusCRM;
                    this.candidatsForm.campusName = this.candidatsForm.campusChoosen.attributes.name;
                    this.candidatsForm.niveauDiplome = this.niveauDiplomes.find(niveau=>{
                        return this.candidatsForm.niveau == niveau.id
                    }).attributes.description;


                    // send url, diplomq ID and prefix of campus
                    this.candidatsForm.campusDiplomaId = this.candidatsForm.diplomeChoosen?.mapId.get(this.candidatsForm?.campusChoosen?.attributes?.prefix)
                    this.candidatsForm.url = window.location.host + "" + this.$nuxt.$route.path;
                    this.candidatsForm.campusPrefix = this.candidatsForm.campusChoosen?.attributes?.prefix;
                    this.candidatsForm.utm = JSON.stringify(this.$store.state.utm);

                    delete this.candidatsForm.campusChoosen;
                    delete this.candidatsForm.diplomeChoosen;

                    let formData = new FormData();
                    formData.append('cv', this.candidatsForm.cv);
                    this.candidatsForm.cv = this.candidatsForm.cv?.name
                    formData.append('data', JSON.stringify(this.candidatsForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}candidature_form_offre_emploi.php?`, formData);
                    if (result == "success") {
                        this.formSent = true;
                    } else if(result.code == 'alreadyExist'){
                        // display popup
                        this.sending = false;
                        this.dublon = true;
                        this.isOpen = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }
                } 
            }catch(error){
                this.sending = false;
                this.isOpen = true
            }
        },
    },

    async asyncData({ params, $http, store }) {
        // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
        // instances = instances.data;

        let instances = JSON.parse(JSON.stringify(store.state.instances));

        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));

        let niveauDiplomes = await $http.$get(`${process.env.strapiBaseUri}/api/niveau-diplomes`);
        niveauDiplomes = niveauDiplomes.data;

        let allDiplomas = JSON.parse(JSON.stringify(store.state.diplomas));
        if (allDiplomas.length == 0) {
            for (const instance of instances) {
                const campusUrl = `${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas?populate=domaine,niveauDiplome`;
                const campusDiplomaInfos = await $http.$get(campusUrl);
                campusDiplomaInfos.data.map(diplome => {
                    diplome.campus = instance.attributes.prefix;
                })
                allDiplomas = allDiplomas.concat(campusDiplomaInfos.data)
            }
            store.commit('setDiplomas', JSON.parse(JSON.stringify(allDiplomas)))
        }

        let bacSeries = await $http.$get(`${process.env.apiCrmServer}bac.php?query=series`);
        bacSeries = bacSeries.filter(bacSerie => bacSerie.serie);
        let bacs = await $http.$get(`${process.env.apiCrmServer}bac.php?query=bacs`);
        let displayedBacs = bacs;

        return {
            instances, niveauDiplomes, bacSeries, bacs, infoGenerales,
            displayedBacs, allDiplomas
        }
    }
}
